import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faInstagram,
  faTwitter,
  faTelegram,
  faWhatsapp,
} from '@fortawesome/free-brands-svg-icons'
import { faEnvelope, faPhone } from '@fortawesome/free-solid-svg-icons'
import { makeNumbersFarsi } from '../utils/farsi'

export const FooterInfo = () => {
  const navigation = [
    { name: 'درباره ما', href: '/about' },
    { name: 'تماس با ما ', href: '/contact-us' },
    // { name: 'سبد خرید', href: '/cart' },
    { name: 'قوانین و مقررات', href: '/terms' },
    { name: 'ورود / ثبت نام', href: '/login' },
  ]

  const enamadHref =
    'https://trustseal.enamad.ir/?id=580858&Code=2THlVlQK7xUp0BoRGPEqMnOkW8Y0xteV'
  const enamadLogoSrc =
    'https://trustseal.enamad.ir/logo.aspx?id=580858&Code=2THlVlQK7xUp0BoRGPEqMnOkW8Y0xteV'

  return (
    <>
      <div
        className='w-full'
        style={{ backgroundColor: 'var(--accent-secondary)' }}
      >
        <div className='w-[90%] mx-auto flex flex-col md:flex-row items-start md:items-center justify-between py-4'>
          <div className='flex items-center my-2 md:my-0'>
            <img
              alt='call center logo'
              src='/assets/icons/call-center.png'
              className='feature-icon w-7 h-7 md:w-9 md:h-9'
            />
            <h3 className='text-white font-medium text-sm md:text-base font-medium mr-2 mt-3'>
              پشتیبانی تلفنی
            </h3>
          </div>
          <div className='flex items-center my-2 md:my-0'>
            <img
              alt='guarantee logo'
              src='/assets/icons/guarantee.png'
              className='feature-icon w-7 h-7 md:w-9 md:h-9'
            />
            <h3 className='text-white font-medium text-sm md:text-base font-medium mr-2 mt-3'>
              تضمین کیفیت کتاب
            </h3>
          </div>
          <div className='flex items-center my-2 md:my-0'>
            <img
              alt='7 days money back logo'
              src='/assets/icons/7-days-money-back.png'
              className='feature-icon w-7 h-7 md:w-9 md:h-9'
            />
            <h3 className='text-white font-medium text-sm md:text-base font-medium mr-2 mt-3'>
              ضمانت بازگشت وجه
            </h3>
          </div>
          <div className='flex items-center my-2 md:my-0'>
            <img
              alt='buy book logo'
              src='/assets/icons/buy.png'
              className='feature-icon w-7 h-7 md:w-9 md:h-9'
            />
            <h3 className='text-white font-medium text-sm md:text-base font-medium mr-2 mt-2'>
              ترویج اقتصاد چرخشی
            </h3>
          </div>
        </div>
      </div>
      <div
        className='w-[85%] mx-auto flex items-center justify-between py-4 border-b'
        style={{ borderColor: 'rgba(255,255,255,0.1)' }}
      >
        <div className='flex flex-col'>
          <h1 className='text-white font-bold text-xl rounded p-1 text-left md:text-right'>
            BookStory
          </h1>
          <h3 className='text-white font-medium font-medium text-sm rounded p-1'>
            آدرس: تبریز- خیابان هفده شهریور جدید - جنب کلینیک فرهنگیان - ساختمان
            چهل و چهار - طبقه سوم
          </h3>
          <h3 className='text-white font-medium font-medium text-sm rounded p-1'>
            کد پستی: {makeNumbersFarsi('5138794458')}
          </h3>
        </div>
        <div className='hidden md:block'>
          <a
            href={enamadHref}
            target='_blank'
            rel='noopener noreferrer'
            aria-label='enamad trust seal'
            referrerPolicy='origin'
          >
            <img
              src={enamadLogoSrc}
              alt='enamad trust seal'
              style={{ cursor: 'pointer' }}
              referrerPolicy='origin'
            />
          </a>
        </div>
      </div>
      <div
        className='w-[85%] mx-auto flex flex-col md:flex-row items-start justify-between border-b'
        style={{ borderColor: 'rgba(255,255,255,0.1)' }}
      >
        <div className='flex flex-col items-start py-3'>
          {navigation.map((item) => (
            <Link
              to={item.href}
              key={item.name}
              className='text-white font-medium text-sm rounded p-1'
            >
              {item.name}
            </Link>
          ))}
        </div>
        <div className='flex flex-col items-start md:items-end my-3'>
          <div className='flex items-center'>
            <FontAwesomeIcon
              icon={faEnvelope}
              style={{ fontSize: 28, marginLeft: 10 }}
            />
            <a
              href='mailto:support@gobookstory.com'
              className='transition ease-in-out delay-150 text-white hover:bg-bermuda hover:text-tahiti hover:-translate-y-1 hover:scale-100 duration-300 py-1 text-sm font-medium rounded-lg '
            >
              support@gobookstory.com
            </a>
          </div>
          <div className='flex items-center'>
            <FontAwesomeIcon
              icon={faPhone}
              style={{ fontSize: 28, marginLeft: 10 }}
            />
            <a
              href=''
              className='transition ease-in-out delay-150 text-white hover:bg-bermuda hover:text-tahiti hover:-translate-y-1 hover:scale-100 duration-300 py-1 text-sm font-medium rounded-lg my-2'
            >
              {makeNumbersFarsi('09146391548')}
            </a>
          </div>
        </div>
      </div>
      <div className='w-[85%] mx-auto flex items-center justify-center border-b py-3'>
        <a
          href='https://wa.me/message/W63YGS7YP54UG1'
          className='faIcon transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-100 duration-200 hover:text-tahiti'
          target='_blank'
          rel='noreferrer'
        >
          <FontAwesomeIcon
            icon={faWhatsapp}
            style={{ fontSize: 32, margin: 8 }}
          />
        </a>
        <a
          href='https://www.instagram.com/gobookstory/'
          className='faIcon transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-100 duration-200 hover:text-tahiti'
          target='_blank'
          rel='noreferrer'
        >
          <FontAwesomeIcon
            icon={faInstagram}
            style={{
              fontSize: 32,
              margin: 8,
            }}
          />
        </a>

        <a
          href='https://twitter.com/gobookstory'
          className='faIcon transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-100 duration-200 hover:text-tahiti'
          target='_blank'
          rel='noreferrer'
        >
          <FontAwesomeIcon
            icon={faTwitter}
            style={{ fontSize: 32, margin: 8 }}
          />
        </a>

        <a
          href='https://t.me/gobookstory'
          className='faIcon transition ease-in-out delay-150 hover:-translate-y-1 hover:scale-100 duration-200 hover:text-tahiti'
          target='_blank'
          rel='noreferrer'
        >
          <FontAwesomeIcon
            icon={faTelegram}
            style={{ fontSize: 32, margin: 8 }}
          />
        </a>
      </div>
      <div className='flex flex-col items-center font-medium py-2'>
        <h3 className='text-white text-xs text-center md:text-sm font-medium'>
          کلیه حقوق مادی و معنوی این وبسایت متعلق به بوک استوری می باشد.
        </h3>
      </div>
    </>
  )
}

export default FooterInfo
